import { saveAs } from 'file-saver'
import xlsx from 'xlsx'
import Axios from 'axios'
import store from '@/store/root'
import { base64StringToBlob } from 'blob-util'

const getPdfEndpoint = async () => {
    const configs = await store.dispatch('config/updatePdfConfig')
    return configs.endpoint
}

const initExcelOrderHeader = [
    [
        'order_number',
        'Tracking No.',
        'name',
        'phone',
        'phoneSec',
        'address',
        'district',
        'amphoe',
        'province',
        'zipcode',
        'tag',
        'shipping_method',
        'payment',
        'price',
        'deliveryCost',
        'deliveryCostService',
        'actualWeight',
        'dimWeight',
        'create',
        'note',
        'transfer time',
        'bank',
        'amount transfer',
        'last status update time',
        'Order status',
        'contact method',
        'create_by',
        'printed',
        'user',
        'accCode',
        'shop',
        'Shop Id',
        'Shop Code',
        'Agent Name',
        'Pick Up Date',
        'codServicePrice',
        'delServicePrice',
        'returnWeight'
    ]
]

const initExcelProductHeader = [
    [
        'productId',
        'sku',
        'name',
        'price',
        'stockType',
        'weight',
        'width',
        'length',
        'height',
        'color',
        'category',
        'status',
        'createdAt',
        'deletedAt'
    ]
]

const initExcelScgStatusHeaderFull = [
    [
        'created_at',
        'shop_name',
        'order_number',
        'tracking_number',
        'customer_name',
        'phone_number',
        'payment_type',
        'zipcode',
        'order_status',
        'status_date',
        'scg_order_status'
    ]
]
const initExcelScgStatusHeaderSub = [
    [
        'created_at',
        'shop_name',
        'order_number',
        'tracking_number',
        'customer_name',
        'phone_number',
        'payment_type',
        'zipcode',
        'order_status',
        'status_date',
        'start_date',
        'last_date_status',
        'last_status',
        'scgLastStatus',
        'scgOrderStatus'
    ]
]

const initExcelPaymentOrderAll = [
    [
        'No.',
        'Shop name',
        'Pickup date',
        'Delivered Date',
        'Courier Parcel ID',
        'Customer Reference ID',
        'Consignee Name',
        'Deposit Date',
        'Cod DB',
        'Cod Excel',
        'Agent name',
        'Shop Code',
        'Customer_id'
    ]
]

export default {
    data () {
        return {
            excelOrderHeader: [...initExcelOrderHeader],
            excelProductHeader: [...initExcelProductHeader],
            excelScgStatusHeaderFull: [...initExcelScgStatusHeaderFull],
            excelScgStatusHeaderSub: [...initExcelScgStatusHeaderSub],
            excelPaymentOrderAll: [...initExcelPaymentOrderAll]
        }
    },
    methods: {
        saveCsv (exportData, filename) {
            let wscols = [
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 }
            ]
            let worksheet = xlsx.utils.aoa_to_sheet(exportData)
            worksheet['!cols'] = wscols
            let workbook = xlsx.utils.book_new()
            xlsx.utils.book_append_sheet(workbook, worksheet, 'SheetJS')
            xlsx.writeFile(workbook, filename + '.csv')
            this.ClearHeaderExcelFile()
        },
        saveExcel (exportData, filename) {
            let wscols = [
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 }
            ]
            let worksheet = xlsx.utils.aoa_to_sheet(exportData)
            worksheet['!cols'] = wscols
            let workbook = xlsx.utils.book_new()
            xlsx.utils.book_append_sheet(workbook, worksheet, 'SheetJS')
            xlsx.writeFile(workbook, filename + '.xlsx')
            this.ClearHeaderExcelFile()
        },
        saveExcelScgNotify (exportData, filename) {
            let wscols = [
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
                { wch: 30 },
                { wch: 70 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 70 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 }
            ]

            let worksheet = xlsx.utils.aoa_to_sheet(exportData)
            worksheet['!cols'] = wscols

            let workbook = xlsx.utils.book_new()
            xlsx.utils.book_append_sheet(workbook, worksheet, 'SCG notify')
            let wopts = { bookType: 'xlsx', bookSST: false, type: 'binary' }
            let wbout = xlsx.write(workbook, wopts)
            let s2ab = s => {
                let buf = new ArrayBuffer(s.length)
                let view = new Uint8Array(buf)
                for (let i = 0; i !== s.length; ++i) {
                    view[i] = s.charCodeAt(i) & 0xff
                }
                return buf
            }
            saveAs(
                new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
                filename + '.xlsx'
            )
            this.ClearHeaderExcelFile()
        },
        getExcelFile (exportData, filename) {
            let wscols = [
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 }
            ]
            let worksheet = xlsx.utils.aoa_to_sheet(exportData)
            worksheet['!cols'] = wscols
            let workbook = xlsx.utils.book_new()
            xlsx.utils.book_append_sheet(workbook, worksheet, 'SheetJS')
            let wopts = { bookType: 'xlsx', bookSST: false, type: 'binary' }
            let wbout = xlsx.write(workbook, wopts)
            let s2ab = s => {
                let buf = new ArrayBuffer(s.length)
                let view = new Uint8Array(buf)
                for (let i = 0; i !== s.length; ++i) {
                    view[i] = s.charCodeAt(i) & 0xff
                }
                return buf
            }
            return [
                new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
                filename + '.xlsx'
            ]
        },
        saveExcelForPayment (exportData, filename, wscols, mergeAttr) {
            let worksheet = xlsx.utils.aoa_to_sheet(exportData)
            worksheet['!merges'] = mergeAttr
            worksheet['!cols'] = wscols
            let workbook = xlsx.utils.book_new()
            xlsx.utils.book_append_sheet(workbook, worksheet, 'payment_advice')
            let wopts = { bookType: 'xlsx', bookSST: false, type: 'binary' }
            let wbout = xlsx.write(workbook, wopts)
            const s2ab = s => {
                let buf = new ArrayBuffer(s.length)
                let view = new Uint8Array(buf)
                for (let i = 0; i !== s.length; ++i) {
                    view[i] = s.charCodeAt(i) & 0xff
                }
                return buf
            }
            // saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), obj.cusotmerInfo.acc_code + '-FGPA' + moment(this.arrDepositeDate[0], 'D/M/YYYY').format("YYYYMMDD") + '' + pad(obj.payment_advice, 4) + ".xlsx")
            saveAs(
                new Blob([s2ab(wbout)], {
                    type: 'application/octet-stream'
                }),
                filename + '.xlsx'
            )
            this.ClearHeaderExcelFile()
        },
        saveInvoiceExcel (exportData, filename, wscols, mergeAttr) {
            let workbook = xlsx.utils.book_new()
            exportData.forEach(e => {
                console.log(e)
                let worksheet = xlsx.utils.aoa_to_sheet(e.excelData)
                worksheet['!merges'] = mergeAttr
                worksheet['!cols'] = wscols
                Object.keys(worksheet).forEach(function (s) {
                    if (worksheet[s].t === 'n') { worksheet[s].z = '0.00' }
                })

                xlsx.utils.book_append_sheet(
                    workbook,
                    worksheet,
                    e.courierName
                )
            })

            let wopts = { bookType: 'xlsx', bookSST: false, type: 'binary' }
            let wbout = xlsx.write(workbook, wopts)
            const s2ab = s => {
                let buf = new ArrayBuffer(s.length)
                let view = new Uint8Array(buf)
                for (let i = 0; i !== s.length; ++i) {
                    view[i] = s.charCodeAt(i) & 0xff
                }
                return buf
            }
            // saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), obj.cusotmerInfo.acc_code + '-FGPA' + moment(this.arrDepositeDate[0], 'D/M/YYYY').format("YYYYMMDD") + '' + pad(obj.payment_advice, 4) + ".xlsx")
            saveAs(
                new Blob([s2ab(wbout)], {
                    type: 'application/octet-stream'
                }),
                filename + '.xlsx'
            )
            this.ClearHeaderExcelFile()
        },
        getExcelFileInvoice (exportData, filename) {
            let workbook = xlsx.utils.book_new()
            exportData.forEach(e => {
                console.log(e)
                let worksheet = xlsx.utils.aoa_to_sheet(e.excelData)

                Object.keys(worksheet).forEach(function (s) {
                    if (worksheet[s].t === 'n') { worksheet[s].z = '0.00' }
                })

                xlsx.utils.book_append_sheet(
                    workbook,
                    worksheet,
                    e.courierName
                )
            })

            let wopts = { bookType: 'xlsx', bookSST: false, type: 'binary' }
            let wbout = xlsx.write(workbook, wopts)
            const s2ab = s => {
                let buf = new ArrayBuffer(s.length)
                let view = new Uint8Array(buf)
                for (let i = 0; i !== s.length; ++i) {
                    view[i] = s.charCodeAt(i) & 0xff
                }
                return buf
            }
            return [
                new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
                filename + '.xlsx'
            ]
        },
        async generatePDFpayment (objPDF) {
            const pdfEndpoint = await getPdfEndpoint()
            let response = await Axios({
                method: 'post',
                url: `${pdfEndpoint}/payment-advice`,
                responseType: 'arraybuffer',
                data: objPDF
            })
            let blob = new Blob([response.data], { type: 'application/pdf' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download =
                objPDF.customerCode + '-' + objPDF.paymentAdviceNumber + '.pdf'
            link.click()
            this.ClearHeaderExcelFile()
        },
        /** @param {json} objPDF  */
        async getPDFpayment (objPDF) {
            const pdfEndpoint = await getPdfEndpoint()
            let response = await Axios({
                method: 'post',
                url: `${pdfEndpoint}/payment-advice`,
                responseType: 'arraybuffer',
                data: objPDF
            })
            return [
                new Blob([response.data], { type: 'application/pdf' }),
                objPDF.customerCode + '-' + objPDF.paymentAdviceNumber + '.pdf'
            ]
        },

        ClearHeaderExcelFile () {
            this.excelPaymentOrderAll = [...initExcelPaymentOrderAll] // clear
            this.excelOrderHeader = [...initExcelOrderHeader]
            this.excelScgStatusHeaderFull = [...initExcelScgStatusHeaderFull]
            this.excelScgStatusHeaderSub = [...initExcelScgStatusHeaderSub]
            this.excelProductHeader = [...initExcelProductHeader]
        },
        async generatePDFInvoice (objPDF) {
            const pdfEndpoint = await getPdfEndpoint()
            try {
                let response = await Axios({
                    method: 'post',
                    url: `${pdfEndpoint}/invoiceOMS`,
                    // url: 'http://localhost:9090/invoiceOMS',
                    responseType: 'arraybuffer',
                    data: objPDF
                })
                console.log(response)
                let blob = new Blob([response.data], { type: 'application/pdf' })
                let link = document.createElement('a')
                link.setAttribute('target', '__blank')
                link.href = window.URL.createObjectURL(blob)
                link.download = objPDF.fileName + '.pdf'
                link.click()
                this.ClearHeaderExcelFile()
            } catch (error) {
                const enc = new TextDecoder('utf-8')
                let errRes = JSON.parse(enc.decode(error.response.data))
                throw new Error(errRes.message.replace('Error:', ''))
            }
        },
        async getPDFInvoice (objPDF) {
            const pdfEndpoint = await getPdfEndpoint()
            let response = await Axios({
                method: 'post',
                url: `${pdfEndpoint}/invoiceOMS`,
                responseType: 'arraybuffer',
                data: objPDF
            })
            return [
                new Blob([response.data], { type: 'application/pdf' }),
                objPDF.fileName + '.pdf'
            ]
        },
        async getPDFInvoices (objPDF, txID) {
            let response = await Axios({
                method: 'post',
                url: `https://invoice-test.api-fillgoods.com/invoiceOMSs?${txID}'`,
                responseType: 'json',
                data: {
                    data: objPDF
                }
            })

            if (response.status === 200) {
                const data = response.data.data
                const blobs = []
                for (let i = 0; i < data.length; i++) {
                    blobs.push(base64StringToBlob(data[i], 'application/pdf'))
                }

                return blobs
            }

            return false
        },
        async getExcelGenerate (ExcelDetail, fileName) {
            let response = await Axios({
                method: 'post',
                url: 'https://njsdev.api-fillgoods.com/excel/invoice',
                // url: 'http://localhost:9090/excel/pick-up',
                responseType: 'arraybuffer',
                data: ExcelDetail
            })
            console.log(response)
            let blob = new Blob([response.data], {
                type: 'application/octet-stream'
            })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = fileName + '.xlsx'
            link.click()
        }
    }
}
